import { render, staticRenderFns } from "./review-component-button.vue?vue&type=template&id=43a4a712&scoped=true"
import script from "./review-component-button.vue?vue&type=script&lang=js"
export * from "./review-component-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a4a712",
  null
  
)

export default component.exports